/* tslint:disable */
/* eslint-disable */
/**
 * grpc/calendar/calendar.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { CalendarCreateCalendarEntryRequest } from '../models'
// @ts-ignore
import { CalendarCreateCalendarEntryResponse } from '../models'
// @ts-ignore
import { CalendarGetCalendarEntryResponse } from '../models'
// @ts-ignore
import { CalendarListCalendarEntriesResponse } from '../models'
// @ts-ignore
import { CalendarServiceUpdateCalendarEntryBody } from '../models'
// @ts-ignore
import { CalendarUpdateCalendarEntryResponse } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
/**
 * CalendarServiceApi - axios parameter creator
 * @export
 */
export const CalendarServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Создать запись календаря
     * @param {CalendarCreateCalendarEntryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceCreateCalendarEntry: async (
      body: CalendarCreateCalendarEntryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('calendarServiceCreateCalendarEntry', 'body', body)
      const localVarPath = `/api/v1/calendar/entries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Удалить запись календаря
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceDeleteCalendarEntry: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('calendarServiceDeleteCalendarEntry', 'id', id)
      const localVarPath = `/api/v1/calendar/entries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Получить запись календаря по ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceGetCalendarEntry: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('calendarServiceGetCalendarEntry', 'id', id)
      const localVarPath = `/api/v1/calendar/entries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Список записей календаря с фильтрами
     * @param {string} [managerId] Фильтры
     * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType]  - ENTITY_TYPE_CLIENT: Клиент из client-data  - ENTITY_TYPE_DEAL: Сделка из deals  - ENTITY_TYPE_DEAL_TASK: Задача сделки из deals  - ENTITY_TYPE_CLIENT_TASK: Задача клиента из client-data (DEV-240)
     * @param {string} [entityId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [search]
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntries: async (
      managerId?: string,
      entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
      entityId?: string,
      startDate?: string,
      endDate?: string,
      search?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/calendar/entries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType
      }

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Записи календаря по связанной сущности
     * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntriesByEntity: async (
      entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
      entityId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityType' is not null or undefined
      assertParamExists('calendarServiceListCalendarEntriesByEntity', 'entityType', entityType)
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('calendarServiceListCalendarEntriesByEntity', 'entityId', entityId)
      const localVarPath = `/api/v1/calendar/entities/{entityType}/{entityId}/entries`
        .replace(`{${'entityType'}}`, encodeURIComponent(String(entityType)))
        .replace(`{${'entityId'}}`, encodeURIComponent(String(entityId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Обновить запись календаря
     * @param {string} id
     * @param {CalendarServiceUpdateCalendarEntryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceUpdateCalendarEntry: async (
      id: string,
      body: CalendarServiceUpdateCalendarEntryBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('calendarServiceUpdateCalendarEntry', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('calendarServiceUpdateCalendarEntry', 'body', body)
      const localVarPath = `/api/v1/calendar/entries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CalendarServiceApi - functional programming interface
 * @export
 */
export const CalendarServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CalendarServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Создать запись календаря
     * @param {CalendarCreateCalendarEntryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceCreateCalendarEntry(
      body: CalendarCreateCalendarEntryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarCreateCalendarEntryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceCreateCalendarEntry(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceCreateCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Удалить запись календаря
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceDeleteCalendarEntry(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceDeleteCalendarEntry(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceDeleteCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Получить запись календаря по ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceGetCalendarEntry(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGetCalendarEntryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceGetCalendarEntry(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceGetCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Список записей календаря с фильтрами
     * @param {string} [managerId] Фильтры
     * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType]  - ENTITY_TYPE_CLIENT: Клиент из client-data  - ENTITY_TYPE_DEAL: Сделка из deals  - ENTITY_TYPE_DEAL_TASK: Задача сделки из deals  - ENTITY_TYPE_CLIENT_TASK: Задача клиента из client-data (DEV-240)
     * @param {string} [entityId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [search]
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceListCalendarEntries(
      managerId?: string,
      entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
      entityId?: string,
      startDate?: string,
      endDate?: string,
      search?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarListCalendarEntriesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceListCalendarEntries(
        managerId,
        entityType,
        entityId,
        startDate,
        endDate,
        search,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceListCalendarEntries']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Записи календаря по связанной сущности
     * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceListCalendarEntriesByEntity(
      entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
      entityId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarListCalendarEntriesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.calendarServiceListCalendarEntriesByEntity(
          entityType,
          entityId,
          paginationPage,
          paginationPerPage,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceListCalendarEntriesByEntity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Обновить запись календаря
     * @param {string} id
     * @param {CalendarServiceUpdateCalendarEntryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceUpdateCalendarEntry(
      id: string,
      body: CalendarServiceUpdateCalendarEntryBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarUpdateCalendarEntryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceUpdateCalendarEntry(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceUpdateCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CalendarServiceApi - factory interface
 * @export
 */
export const CalendarServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CalendarServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Создать запись календаря
     * @param {CalendarCreateCalendarEntryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceCreateCalendarEntry(
      body: CalendarCreateCalendarEntryRequest,
      options?: any,
    ): AxiosPromise<CalendarCreateCalendarEntryResponse> {
      return localVarFp
        .calendarServiceCreateCalendarEntry(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Удалить запись календаря
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceDeleteCalendarEntry(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .calendarServiceDeleteCalendarEntry(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Получить запись календаря по ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceGetCalendarEntry(
      id: string,
      options?: any,
    ): AxiosPromise<CalendarGetCalendarEntryResponse> {
      return localVarFp
        .calendarServiceGetCalendarEntry(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Список записей календаря с фильтрами
     * @param {string} [managerId] Фильтры
     * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType]  - ENTITY_TYPE_CLIENT: Клиент из client-data  - ENTITY_TYPE_DEAL: Сделка из deals  - ENTITY_TYPE_DEAL_TASK: Задача сделки из deals  - ENTITY_TYPE_CLIENT_TASK: Задача клиента из client-data (DEV-240)
     * @param {string} [entityId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [search]
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntries(
      managerId?: string,
      entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
      entityId?: string,
      startDate?: string,
      endDate?: string,
      search?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<CalendarListCalendarEntriesResponse> {
      return localVarFp
        .calendarServiceListCalendarEntries(
          managerId,
          entityType,
          entityId,
          startDate,
          endDate,
          search,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Записи календаря по связанной сущности
     * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntriesByEntity(
      entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
      entityId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<CalendarListCalendarEntriesResponse> {
      return localVarFp
        .calendarServiceListCalendarEntriesByEntity(
          entityType,
          entityId,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Обновить запись календаря
     * @param {string} id
     * @param {CalendarServiceUpdateCalendarEntryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceUpdateCalendarEntry(
      id: string,
      body: CalendarServiceUpdateCalendarEntryBody,
      options?: any,
    ): AxiosPromise<CalendarUpdateCalendarEntryResponse> {
      return localVarFp
        .calendarServiceUpdateCalendarEntry(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * CalendarServiceApi - object-oriented interface
 * @export
 * @class CalendarServiceApi
 * @extends {BaseAPI}
 */
export class CalendarServiceApi extends BaseAPI {
  /**
   *
   * @summary Создать запись календаря
   * @param {CalendarCreateCalendarEntryRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceCreateCalendarEntry(
    body: CalendarCreateCalendarEntryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceCreateCalendarEntry(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Удалить запись календаря
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceDeleteCalendarEntry(id: string, options?: RawAxiosRequestConfig) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceDeleteCalendarEntry(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Получить запись календаря по ID
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceGetCalendarEntry(id: string, options?: RawAxiosRequestConfig) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceGetCalendarEntry(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Список записей календаря с фильтрами
   * @param {string} [managerId] Фильтры
   * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType]  - ENTITY_TYPE_CLIENT: Клиент из client-data  - ENTITY_TYPE_DEAL: Сделка из deals  - ENTITY_TYPE_DEAL_TASK: Задача сделки из deals  - ENTITY_TYPE_CLIENT_TASK: Задача клиента из client-data (DEV-240)
   * @param {string} [entityId]
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {string} [search]
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceListCalendarEntries(
    managerId?: string,
    entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
    entityId?: string,
    startDate?: string,
    endDate?: string,
    search?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceListCalendarEntries(
        managerId,
        entityType,
        entityId,
        startDate,
        endDate,
        search,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Записи календаря по связанной сущности
   * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
   * @param {string} entityId
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceListCalendarEntriesByEntity(
    entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
    entityId: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceListCalendarEntriesByEntity(
        entityType,
        entityId,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Обновить запись календаря
   * @param {string} id
   * @param {CalendarServiceUpdateCalendarEntryBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceUpdateCalendarEntry(
    id: string,
    body: CalendarServiceUpdateCalendarEntryBody,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceUpdateCalendarEntry(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const CalendarServiceListCalendarEntriesEntityTypeEnum = {
  Invalid: 'ENTITY_TYPE_INVALID',
  Client: 'ENTITY_TYPE_CLIENT',
  Deal: 'ENTITY_TYPE_DEAL',
  DealTask: 'ENTITY_TYPE_DEAL_TASK',
  ClientTask: 'ENTITY_TYPE_CLIENT_TASK',
} as const
export type CalendarServiceListCalendarEntriesEntityTypeEnum =
  (typeof CalendarServiceListCalendarEntriesEntityTypeEnum)[keyof typeof CalendarServiceListCalendarEntriesEntityTypeEnum]
/**
 * @export
 */
export const CalendarServiceListCalendarEntriesByEntityEntityTypeEnum = {
  Invalid: 'ENTITY_TYPE_INVALID',
  Client: 'ENTITY_TYPE_CLIENT',
  Deal: 'ENTITY_TYPE_DEAL',
  DealTask: 'ENTITY_TYPE_DEAL_TASK',
  ClientTask: 'ENTITY_TYPE_CLIENT_TASK',
} as const
export type CalendarServiceListCalendarEntriesByEntityEntityTypeEnum =
  (typeof CalendarServiceListCalendarEntriesByEntityEntityTypeEnum)[keyof typeof CalendarServiceListCalendarEntriesByEntityEntityTypeEnum]
